// src/utils/parseFile.js
import * as XLSX from "xlsx";
import Papa from "papaparse";

/**
 * parseFile(file) => { rows: Array<Object>, errors: Array<{line, message}> }
 * - Accepts File object (.csv, .xlsx, .xls)
 * - Returns parsed rows and any parsing errors
 */
export async function parseFile(file) {
  const name = file.name.toLowerCase();
  if (name.endsWith(".csv")) {
    // Use PapaParse
    return new Promise((resolve) => {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const rows = results.data;
          const errors = (results.errors || []).map((e) => ({
            line: e.row + 1,
            message: e.message || "CSV parse error",
          }));
          resolve({ rows, errors });
        },
        error: (err) => {
          resolve({ rows: [], errors: [{ line: 0, message: err.message }] });
        },
      });
    });
  }

  // For xlsx/xls and fallback CSV, use xlsx
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const wb = XLSX.read(data, { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { defval: "" });
        resolve({ rows, errors: [] });
      } catch (err) {
        resolve({ rows: [], errors: [{ line: 0, message: err.message }] });
      }
    };
    reader.onerror = () => resolve({ rows: [], errors: [{ line: 0, message: "File read error" }] });
    reader.readAsArrayBuffer(file);
  });
}
